import React from "react";
import { useOrderStatus } from "../../../../api/order-management/use-order-status";
import { useSetState } from "../../../../utils/hooks";
import { OrderTable } from "../order-table";
import OrderExchangeFilter from "./Section/OrderExchangeFilter";

const searchOptions = [
  { id: 1, name: "상품명" },
  { id: 2, name: "주문번호" },
  { id: 3, name: "주문자(담당자)" },
];

export const OrderExchange = () => {
  const [filter, dispatchFilter] = useSetState();
  const { isEmpty, getDataTableProps } = useOrderStatus(filter, "EXCHANGED");
  return (
    <>
      <OrderExchangeFilter onFilter={dispatchFilter} options={searchOptions} />
      <OrderTable isEmpty={isEmpty} getDataTableProps={getDataTableProps} />
    </>
  );
};
